import React from "react";
import { useForm, ValidationError } from "@formspree/react";
import ReCAPTCHA from "react-google-recaptcha";
import Navbar from "../Navbar/Navbar";
import Footer from "../Home/Footer";
import "./Contact.css";

/* ---- Custom SVG icons ---- */
function MapPinIcon(props) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none">
      <path d="M12 12.5C13.38 12.5 14.5 11.38 14.5 10C14.5 8.62 13.38 7.5 12 7.5C10.62 7.5 9.5 8.62 9.5 10C9.5 11.38 10.62 12.5 12 12.5Z" stroke="currentColor" strokeWidth="2" />
      <path d="M12 21C15 17 19 14.42 19 10C19 6.13 15.87 3 12 3C8.13 3 5 6.13 5 10C5 14.42 9 17 12 21Z" stroke="currentColor" strokeWidth="2" />
    </svg>
  );
}

function MailIcon(props) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none">
      <path d="M4 7L11 11.3C11.6 11.7 12.4 11.7 13 11.3L20 7M5 18H19C20.1 18 21 17.1 21 16V8C21 6.9 20.1 6 19 6H5C3.9 6 3 6.9 3 8V16C3 17.1 3.9 18 5 18Z" stroke="currentColor" strokeWidth="2" />
    </svg>
  );
}

function PhoneIcon(props) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none">
      <path d="M22 17V20C22 20.6 21.5 21.1 20.9 21.1C10.7 20.5 3.5 13.3 2.9 3.1C2.9 2.5 3.4 2 4 2H7C7.6 2 8.1 2.4 8.1 3C8.2 4.3 8.5 5.6 8.9 6.9L6.7 9.1C8.3 12.7 11.3 15.7 14.9 17.3L17.1 15.1C18.4 15.5 19.7 15.8 21 15.9C21.6 15.9 22 16.4 22 17Z" stroke="currentColor" strokeWidth="2" />
    </svg>
  );
}

function ArrowIcon(props) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none">
      <path d="M5 12H19M19 12L12 5M19 12L12 19" stroke="currentColor" strokeWidth="2" />
    </svg>
  );
}

export default function Contact() {
  const [state, handleSubmit] = useForm("mrbybpvd");
  const [captchaValue, setCaptchaValue] = React.useState(null);

  const handleCaptchaChange = (value) => {
    setCaptchaValue(value);
  };

  return (
    <>
      <Navbar />
      <section className="ContactPage" aria-labelledby="ContactPage-title">
        <div className="ContactPage-container">
          {/* LEFT SECTION */}
          <div className="ContactPage-left">
            <p className="ContactPage-eyebrow">THE HISTORIC HARMON</p>
            <h1 id="ContactPage-title" className="ContactPage-title">
              One of the Great Tacoma Landmarks
            </h1>
            <p className="ContactPage-sub">
              The Harmon Property is the pinnacle of both residences and commercial spaces in Tacoma. We look forward to hearing from you!
            </p>

            {/* Contact Info */}
            <div className="ContactPage-infos">
              <div className="ContactPage-info">
                <div className="ContactPage-info-icon">
                  <MapPinIcon className="ContactPage-info-svg" />
                </div>
                <div className="ContactPage-info-content">
                  <h3>We are located at</h3>
                  <p>1944 Pacific Ave., Suite 210, Tacoma, Washington 98402</p>
                </div>
              </div>
              <div className="ContactPage-info">
                <div className="ContactPage-info-icon">
                  <MailIcon className="ContactPage-info-svg" />
                </div>
                <div className="ContactPage-info-content">
                  <h3>Send us an email!</h3>
                  <p>info@harmon.property</p>
                </div>
              </div>
              <div className="ContactPage-info">
                <div className="ContactPage-info-icon">
                  <PhoneIcon className="ContactPage-info-svg" />
                </div>
                <div className="ContactPage-info-content">
                  <h3>Call us!</h3>
                  <p>253-627-2663</p>
                </div>
              </div>
            </div>
          </div>

          {/* RIGHT FORM SECTION */}
          <form className="ContactPage-form" onSubmit={handleSubmit}>
            <h3 className="form-title">Get in Touch</h3>
            <p className="form-subtitle">Interested in The Harmon? Send us a message and our leasing team will contact you as soon as possible.</p>

            {state.succeeded ? (
              <p className="form-success">✅ Your message has been sent!</p>
            ) : (
              <>
                <div className="ContactPage-grid">
                  <div className="ContactPage-input-group">
                    <input type="text" className="ContactPage-input" name="name" placeholder="Name" required />
                    <ValidationError field="name" prefix="Name" errors={state.errors} />
                  </div>

                  <div className="ContactPage-input-group">
                    <input type="email" className="ContactPage-input" name="email" placeholder="Email" required />
                    <ValidationError field="email" prefix="Email" errors={state.errors} />
                  </div>

                  <div className="ContactPage-input-group ContactPage-input-group--full">
                    <input type="tel" className="ContactPage-input" name="phone" placeholder="Phone Number" />
                  </div>

                  <div className="ContactPage-input-group ContactPage-input-group--full">
                    <textarea className="ContactPage-textarea" name="message" rows="6" placeholder="Your Message" required />
                    <ValidationError field="message" prefix="Message" errors={state.errors} />
                  </div>
                </div>

                <div className="recaptcha-container">
                  <ReCAPTCHA
                    sitekey={process.env.REACT_APP_RECAPTCHA_SITE_KEY}
                    onChange={handleCaptchaChange}
                  />
                </div>

                <button
                  type="submit"
                  className="ContactPage-btn"
                  disabled={state.submitting || !captchaValue}
                >
                  SEND MESSAGE
                  <ArrowIcon className="ContactPage-btn-icon" />
                </button>
              </>
            )}
          </form>
        </div>
      </section>
      <Footer />
    </>
  );
}
